import { Controller } from "stimulus"
import { confirmDialog, successDialog, errorDialog } from '../helpers/swal_helper';

export default class extends Controller {
  static targets = [
    "attendanceCreate",
    "attendanceStatus",
    "batchSelect",
    "presentCount",
    "absentCount",
    "lateCount",
    "authorizedAbsentCount"
  ]

  // Handling individual attendance clicks (Present, Absent, Late)
  updateAttendance(event) {
    const label = event.currentTarget
    const input = label.querySelector('input[type="radio"]')
    const row = label.closest("tr")
    const selectedStatus = label.dataset.value

    // Prevent clicks on authorized-absent rows
    if (row?.classList.contains("authorized-absent")) {
      return
    }

    if (!input) {
      console.error("Radio input not found inside label")
      return
    }

    const attendanceStatus = input.value
    const selectedLabel = label.closest("tr").querySelector("label.selected")
    const prevValue = selectedLabel?.querySelector('input')?.value?.split("#")[0]

    // if cell is already selected doesn't trigger an event to the server
    if(selectedLabel == label) {
      return
    }

    this.markAttendanceCell(row, selectedStatus)

    const data = new URLSearchParams({
      student_info: this.chooseDate(),
      attendance: attendanceStatus
    }).toString()

    Rails.ajax({
      url: "/attendances",
      type: "POST",
      data: data,
      dataType: "json",
      success: (response) => {
        if (response.value == null) {
          $.notify("Attendance could not be created on a holiday.", "danger")
        } else {
          $.notify("Attendance created successfully", "success")

          const newValue = response.value
          this.adjustStatusCounts(prevValue, newValue)
        }
      },
      error: (xhr, textStatus, errorThrown) => {
        // Prefer parsed JSON if available, otherwise try responseText
        const response = xhr?.responseJSON ?? (typeof xhr === 'object' ? xhr : null);

        // Extract errors safely
        const errors = response?.errors ?? (xhr?.responseText ? (() => {
          try { return JSON.parse(xhr.responseText).errors } catch(e) { return null }
        })() : null);

        const errorMessage = errors
          ? (Array.isArray(errors) ? errors.join("\n") : String(errors))
          : (xhr?.status === 400 ? "Bad Request" : "An unexpected error occurred");

        $.notify(errorMessage, "danger");
      }
    })
  }

  adjustStatusCounts(prevValue, newValue) {
    if (prevValue) {
      const el = this.getCountTarget(prevValue)
      el.textContent = this.decrementText(el.textContent)
    }

    if (newValue) {
      const el = this.getCountTarget(newValue)
      el.textContent = this.incrementText(el.textContent)
    }
  }

  incrementText(text) {
    const num = parseInt(text)
    return text.replace(num, num + 1)
  }

  decrementText(text) {
    const num = parseInt(text)
    return text.replace(num, Math.max(0, num - 1))
  }

  getCountTarget(status) {
    const base = status.replace(/\s/g, "")
    const targetKey = `${base.charAt(0).toLowerCase()}${base.slice(1)}CountTarget`
    const hasTargetKey = `has${base}CountTarget`

    if (this[hasTargetKey]) {
      return this[targetKey]
      el.textContent = this.incrementText(el.textContent)
    }
  }

  // Mark the attendance cell with the correct color based on the status
  markAttendanceCell(row, status) {
    const labels = row.querySelectorAll('label[data-value]')
    console.debug(`Status ${status}`)

    labels.forEach(label => {
      const labelStatus = label.dataset.value
      label.classList.remove('btn-success', 'btn-danger', 'btn-warning', 'selected')

      if (labelStatus === status) {
        label.classList.add('selected')

        switch (status) {
          case 'Present':
            label.classList.add('btn-success')
            break
          case 'Absent':
            label.classList.add('btn-danger')
            break
          case 'Late':
            label.classList.add('btn-warning')
            break
        }

        const input = label.querySelector('input[type="radio"]')
        if (input) input.checked = true
      }
    })
  }

  // Batch actions for "Mark All" functionality
  async markAll(event) {
    const action = event.target.value
    let url, text, title

    switch (action) {
      case "mark_all_present":
        title = "Are you sure?"
        text = "Are you sure you want to mark all students Present?"
        url = "/mark_all_present"
        break
      case "mark_all_absent":
        title = "Are you sure?"
        text = "Are you sure you want to mark all students Absent?"
        url = "/mark_all_absent"
        break
      case "mark_all_authorised_absent":
        title = "Are you sure?"
        text = "Are you sure you want to mark all students Authorised Absent?"
        url = "/mark_all_authorised_absent"
        break
      default:
        return
    }

    await this.confirmAction(title, text, url)
  }

  // Show a confirmation dialog and proceed with batch action if confirmed
  async confirmAction(title, text, url) {
    const result = await confirmDialog({ title: title, text: text })

    if (result === true || result.isConfirmed) {
      this.handleBatchAction(url)
    } else {
      // Wait a bit before showing error dialog (if necessary)
      await new Promise(resolve => setTimeout(resolve, 200))
      errorDialog()
    }
  }

  // Perform batch action (like marking all students)
  handleBatchAction(url) {
    $.ajax({
      type: "GET",
      url: url,
      data: { class_info: this.chooseDate() },
      success: () => {
        successDialog(
          "Success",
          "Batch attendance action completed successfully"
        )
      },
      error: () => {
        errorDialog(
          "Error",
          "An error occurred while processing the batch action"
        )
      }
    })
  }

  // Utility to get the selected date
  chooseDate() {
    return typeof choose_date !== 'undefined' ? choose_date.value : ""
  }
}
